import { IApplicationState } from '../../../../../../../../types/types';
import { getTimeTrackerState } from './getTimeTrackerState';

export const isTimeTrackerTracking = (
    state: IApplicationState
): boolean => {
    const timeTrackerState = getTimeTrackerState(state);
    return Boolean(timeTrackerState && timeTrackerState.cardId);
};
